export enum FinishStateTypes {
  MessageForResidencyFinishWithNonResident = 2,
  MessageForResidencyFinishWithEmigrant = 3,
  GettingToKnowYou = 5,
  LetsTalkMoney = 6,
  StateTaxes = 8,
  StateFinished = 9
}
